var map = {
	"./account-img.png": "aca0",
	"./bank-card.png": "6703",
	"./computer.png": "48c5",
	"./error-general.png": "a931",
	"./error.png": "b948",
	"./hot-bg.png": "4e47",
	"./icon-result.png": "5868",
	"./icon.png": "f0fc",
	"./investor.png": "e7ca",
	"./login-pwd.png": "fb40",
	"./logo.png": "4ffd",
	"./new-bg.png": "73ac",
	"./no-funds.png": "31ea",
	"./ocrback.png": "e53c",
	"./ocrback_ok.png": "f546",
	"./ocrover.png": "7f11",
	"./ocrover_ok.png": "6ca6",
	"./ocroverother.png": "b1b6",
	"./ocroverother_ok.png": "14a8",
	"./qq_icon.png": "4e85",
	"./register.png": "7d6c",
	"./top1.png": "071b",
	"./top2.png": "c300",
	"./top3.png": "4d59",
	"./trade-pwd.png": "9365",
	"./white-bg.png": "f384",
	"./wx.png": "737d",
	"./wx_icon.png": "f4e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";